import MarketAndState from "../vo/MarketAndState";

export function urlLoginDashboard(salesagentLogin: MarketAndState): string {
  return `https://dashboard.commercelayer.io/oauth/authorize?client_id=${
    salesagentLogin.clientId
  }&redirect_uri=${encodeURIComponent(salesagentLogin.redirectUri)}&scope=${
    salesagentLogin.scope
  }&response_type=code&state=${salesagentLogin.state}`;
}
